"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var compose_react_refs_1 = __importDefault(require("@seznam/compose-react-refs"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_cool_onclickoutside_1 = __importDefault(require("react-cool-onclickoutside"));
var react_transition_group_1 = require("react-transition-group");
var popperUtils_1 = require("../common/popperUtils");
var helpers_1 = require("./helpers");
var react_1 = require("react");
var react_popper_1 = require("react-popper");
var TooltipContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.TooltipContainer {\n    ", "\n  }\n\n  .tooltip__arrowContainer {\n    position: absolute;\n    z-index: -1;\n  }\n\n  .tooltip__arrow {\n    border-radius: 2px;\n    transform: rotate(45deg);\n  }\n\n  &[data-popper-placement^='top'] > .tooltip__arrowContainer {\n    bottom: -7px;\n  }\n  &[data-popper-placement^='bottom'] > .tooltip__arrowContainer {\n    top: -7px;\n  }\n  &[data-popper-placement^='left'] > .tooltip__arrowContainer {\n    right: -7px;\n  }\n  &[data-popper-placement^='right'] > .tooltip__arrowContainer {\n    left: -7px;\n  }\n"], ["\n  &.TooltipContainer {\n    ", "\n  }\n\n  .tooltip__arrowContainer {\n    position: absolute;\n    z-index: -1;\n  }\n\n  .tooltip__arrow {\n    border-radius: 2px;\n    transform: rotate(45deg);\n  }\n\n  &[data-popper-placement^='top'] > .tooltip__arrowContainer {\n    bottom: -7px;\n  }\n  &[data-popper-placement^='bottom'] > .tooltip__arrowContainer {\n    top: -7px;\n  }\n  &[data-popper-placement^='left'] > .tooltip__arrowContainer {\n    right: -7px;\n  }\n  &[data-popper-placement^='right'] > .tooltip__arrowContainer {\n    left: -7px;\n  }\n"])), popperUtils_1.PopperContainer);
var debouncer = function (callback, debounceTimeEntering, debounceTimeExit) {
    if (debounceTimeEntering === void 0) { debounceTimeEntering = 0; }
    if (debounceTimeExit === void 0) { debounceTimeExit = 100; }
    var timeout;
    return function (isEntering) {
        clearTimeout(timeout);
        if (!isEntering) {
            timeout = window.setTimeout(function () { return callback(false); }, debounceTimeExit);
        }
        else if (debounceTimeEntering) {
            timeout = window.setTimeout(function () { return callback(true); }, debounceTimeEntering);
        }
        else {
            callback(true);
        }
    };
};
var Tooltip = function (_a) {
    var closeLabel = _a.closeLabel, description = _a.description, displayTrigger = _a.displayTrigger, id = _a.id, onHintClose = _a.onHintClose, placement = _a.placement, type = _a.type, visible = _a.visible, hoverTimeout = _a.hoverTimeout, className = _a.className, wrapperClassName = _a.wrapperClassName, _b = _a.hoverDelay, hoverDelay = _b === void 0 ? 0 : _b, otherProps = __rest(_a, ["closeLabel", "description", "displayTrigger", "id", "onHintClose", "placement", "type", "visible", "hoverTimeout", "className", "wrapperClassName", "hoverDelay"]);
    var _c = __read(react_1.useState(null), 2), popperElement = _c[0], setPopperElement = _c[1];
    var _d = __read(react_1.useState(null), 2), referenceElement = _d[0], setReferenceElement = _d[1];
    var _e = __read(react_1.useState(false), 2), showHover = _e[0], setShowHover = _e[1];
    var _f = __read(react_1.useState(false), 2), showClick = _f[0], setShowClick = _f[1];
    var handleMouseMove = react_1.useMemo(function () { return debouncer(setShowHover, hoverDelay, hoverTimeout); }, [hoverDelay, hoverTimeout]);
    var ref = react_cool_onclickoutside_1.default(function () { setShowClick(false); }, { disabled: !showClick });
    var _g = react_popper_1.usePopper(referenceElement, popperElement, {
        placement: placement || 'top',
        modifiers: [
            {
                name: 'flip',
                options: {
                    fallbackPlacements: ['bottom', 'right', 'left'],
                },
            },
            {
                name: 'offset',
                options: {
                    offset: [0, type === 'hint' ? 15 : 9],
                },
            },
        ],
    }), styles = _g.styles, attributes = _g.attributes;
    var isVisible = typeof visible !== 'undefined'
        ? visible
        : displayTrigger === 'hover'
            ? showHover
            : showClick;
    var children = React.createElement("div", { className: classnames_1.default('tk-tooltip__wrapper', wrapperClassName), ref: compose_react_refs_1.default(setReferenceElement, ref) }, otherProps.children);
    return (React.createElement(React.Fragment, null,
        displayTrigger === 'hover' &&
            helpers_1.showTooltipOnHover(children, handleMouseMove),
        displayTrigger === 'click' &&
            helpers_1.showTooltipOnClick(children, showClick, setShowClick),
        displayTrigger === undefined && children,
        React.createElement(react_transition_group_1.CSSTransition, __assign({}, popperUtils_1.popperProps, { in: isVisible, classNames: "TooltipContainer" }),
            React.createElement(TooltipContainer, __assign({ id: id, role: "tooltip", ref: setPopperElement, className: classnames_1.default(type === 'tooltip' ? 'tk-tooltip' : 'tk-hint', className), style: styles.popper }, attributes.popper, otherProps, { onMouseEnter: function () { return handleMouseMove(true); }, onMouseLeave: function () { return handleMouseMove(false); } }),
                React.createElement("span", { className: "tk-hint__description" }, description),
                type === 'hint' && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "tooltip__arrowContainer", style: styles.arrow, "data-popper-arrow": true },
                        React.createElement("div", { className: "tooltip__arrow tk-hint__arrow" })),
                    React.createElement("div", { className: "tk-hint__footer" }, closeLabel ? (React.createElement("span", { className: "tk-hint__close", onClick: onHintClose, onKeyDown: function (event) { return (event.key === 'Enter') && onHintClose(); }, tabIndex: 0 }, closeLabel)) : null)))))));
};
Tooltip.defaultProps = {
    type: 'hint',
};
Tooltip.propTypes = {
    children: PropTypes.any,
    closeLabel: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    displayTrigger: PropTypes.oneOf(['click', 'hover']),
    id: PropTypes.string,
    onHintClose: PropTypes.func,
    placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    type: PropTypes.oneOf(['hint', 'tooltip']),
    visible: PropTypes.bool,
    hoverTimeout: PropTypes.number,
    className: PropTypes.string,
    hoverDelay: PropTypes.number,
    wrapperClassName: PropTypes.string,
};
exports.default = Tooltip;
var templateObject_1;
